<div *ngIf="(LocalDatasource && LocalDatasource.length == 0) && !ActiveQuestionSet" class="noRecords"><span translate>LBL.NO_RECORD_FOUND</span></div>

<ng-container *ngIf="LocalDatasource || ActiveQuestionSet">
    <div class="row">
        <div class="col">
            <div class="grdTable tableHover questionnaire-set">
                <div class="row no-gutters grdTableHeader">
                    <div class="col-auto grdHead mr-2"></div>
                    <div class="col-4 grdHead" translate>LBL.TEMPLATE_NAME</div>
                    <div class="col grdHead text-right" translate>LBL.EXECUTIONS</div>
                    <!--<div class="col grdHead text-right" translate>LBL.MODIFIED_BY</div>-->
                    <div class="col grdHead text-right" translate>LBL.CREATED_ON</div>
                    <div class="col grdHead text-right" translate>LBL.ACTIVATED_ON</div>
                    <div class="col grdHead text-right" translate>LBL.DEACTIVATED_ON</div>
                </div>
                <div class="row no-gutters grdTableHeader active-question-set border-bottom"
                     *ngIf="ActiveQuestionSet"
                     (click)="onRowSelected(ActiveQuestionSet)"
                     [ngClass]="{'selected': SelectedQuestionSet && ActiveQuestionSet.Id == SelectedQuestionSet.Id}">


                    <div class="ml-2 mr-2 col-auto grdCol">
                        <div class="text-center statusIcon-Standard" [ngClass]="ActiveQuestionSet.StatusClass"></div>
                    </div>
                    <div class="col-4 pl-2 grdCol">{{ActiveQuestionSet.TemplateName}}</div>

                    <div class="col grdCol text-right">{{ActiveQuestionSet.ExecutionCount}}</div>
                    <!--<div class="col grdCol text-right"></div>-->
                    <div class="col grdCol text-right">
                        {{ActiveQuestionSet.CreatedOnDate  | amDateFormat: DateFormat}}
                    </div>
                    <div class="col grdCol text-right" [ngClass]="{'text-success': ActiveQuestionSet.Status == QuestionSetStatus.Active}">
                        {{ ActiveQuestionSet.LastActivatedDate | amDateFormat: DateFormat}}
                    </div>
                    <div class="col grdCol text-right" [ngClass]="{'text-danger': ActiveQuestionSet.Status != QuestionSetStatus.Active}">
                        {{ActiveQuestionSet.LastDeactivatedDate  | amDateFormat: DateFormat}}
                    </div>

                </div>
                <div class="grdBodyScroll-Expanding" #scrollingBlock>
                    <virtual-scroller #scroll [items]="LocalDatasource" style="height:100%" [parentScroll]="scrollingBlock.nativeElement">
                        <div *ngFor="let row of scroll.viewPortItems"
                             class="row no-gutters grdRow"
                             (click)="onRowSelected(row)"
                             [ngClass]="{'selected': SelectedQuestionSet && row.Id == SelectedQuestionSet.Id}">

                            <div class="ml-2 mr-2 col-auto grdCol">
                                <div class="text-center statusIcon-Standard" [ngClass]="row.StatusClass"></div>
                            </div>
                            <div class="col-4 pl-2 grdCol">{{row.TemplateName}}</div>
                            <div class="col grdCol text-right">{{row.ExecutionCount}}</div>
                            <!--<div class="col grdCol text-right"></div>-->
                            <div class="col grdCol text-right">
                                {{row.CreatedOnDate  | amDateFormat: DateFormat}}
                            </div>
                            <div class="col grdCol text-right" [ngClass]="{'text-success': row.Status == QuestionSetStatus.Active}">
                                {{ row.LastActivatedDate | amDateFormat: DateFormat}}
                            </div>
                            <div class="col grdCol text-right" [ngClass]="{'text-danger': row.Status != QuestionSetStatus.Active}">
                                {{row.LastDeactivatedDate  | amDateFormat: DateFormat}}
                            </div>
                        </div>
                    </virtual-scroller>
                </div>
            </div>

            <!--<div class="grdGrid">
                <sk-wave [isRunning]="IsSubmitting"></sk-wave>
                <div class="grdRow row pointer no-gutters jobdetails pt-1 pb-1"
                     id="questionSet-{{row.Id}}"
                     *ngFor="let row of LocalDatasource; let index = index"
                     tabindex="0"
                     (keyup.enter)="onRowSelected(row)"
                     (click)="onRowSelected(row)"
                     [ngClass]="{'selected': SelectedQuestionSet && row.Id == SelectedQuestionSet.Id}">

                    <div class="ml-4 mr-4 col-auto">
                        <div class="text-center statusIcon-Standard" [ngClass]="row.StatusClass"></div>
                    </div>
                    <div class="col-6 pl-2">{{row.TemplateName}}</div>
                    <div class="col-auto pl-3 pr-3"><small class="text-muted">Created</small> <br/>{{row.CreatedOnDate  | amDateFormat: DateFormat}}</div>
                    <div class="col-auto pl-4 pr-3"  [ngClass]="{'text-success': row.Status == QuestionSetStatus.Active}">
                        <div *ngIf="row.LastActivatedDate">
                            <small>Activated</small> <br />{{ row.LastActivatedDate | amDateFormat: DateFormat}}
                        </div>
                    </div>
                    <div class="col-auto pl-3 pr-3"  [ngClass]="{'text-danger': row.Status != QuestionSetStatus.Active}">
                        <div *ngIf="row.LastDeactivatedDate">
                            <small> Deactivated</small> <br />{{row.LastDeactivatedDate  | amDateFormat: DateFormat}}
                        </div>
                    </div>
                </div>
            </div>-->

        </div>
    </div>


</ng-container>
